import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
 Collapse,
 Alert,
 Card /* , Spinner */,
 Row,
 Col,
 Button,
 Image,
 useAccordionButton,
 Accordion,
 Form
} from 'react-bootstrap';

import UploadFiles from 'components/common/UploadFiles';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import FalconLightBox from 'components/common/FalconLightBox';
import Flex from 'components/common/Flex';
import { currency, noCurrency } from 'helpers/utils';
import Input from 'components/common/Input';
import SimpleBarReact from 'simplebar-react';
import { contextPayment } from 'context';
import numeral from 'numeral';

const CustomToggle = ({ children, eventKey, id, base64, path /* , size */ }) => {
 const decoratedOnClick = useAccordionButton(eventKey);

 return (
  <Flex alignItems="center" key={id + path} className="cursor-pointer">
   <Image rounded width={30} height={30} src={base64} alt={path} onClick={decoratedOnClick} />
   <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1" onClick={decoratedOnClick}>
    <div>
     <h6 className="text-truncate m-0" style={{ maxWidth: '15vw' }}>
      {path}
     </h6>
     <Flex className="position-relative" align="center">
      <p className="mb-0 fs--1 text-400 line-height-1">
       <strong>9898394</strong>
      </p>
     </Flex>
    </div>
   </Flex>
   {children}
  </Flex>
 );
};

const RcbForm = ({ show, watch, register, setValue, errors }) => {
 const { contract } = contextPayment();
 const [a, setA] = useState(0);
 const [amount, setAmount] = useState('');
 const [rcb, setRcb] = useState([]);

 useEffect(() => {
  if (show) {
   setValue('payment_method', {
    type: 'RCB',
    image: '',
    amount: '',
    date: '',
    ref: '',
    account: '',
    description: contract?.project?.detail
     ? contract?.project?.detail
     : contract?.project?.name?.toLowerCase() + ' ' + contract?._id?.slice(-4)
   });
   setRcb([]);
  }
 }, [show]);

 const handleChange = ({ target: { value } }) => {
  const mount = noCurrency(value);
  setAmount(currency(value, true));
  setValue('payment_method.amount', mount);
 };

 useEffect(() => {
  setValue('payment_method.image', rcb.length ? rcb[0].base64 : '');
  /* , {
   shouldValidate: true,
   shouldDirty: true
  } */
 }, [rcb]);

 return (
  <Collapse in={show} appear>
   <div id="example-collapse-text">
    <p className=" bg-100 dark__bg-1100 fs--1 mb-1 long-polling-text">
     Seleccione recibos de consignacion o Transferencias correspondiente a la cuenta de la Empresa, donde se visualice claramente
     los campos.
    </p>
    <Row className="g-0">
     <Col md={6} lg={6} className="p-2">
      <Accordion defaultActiveKey={0} activeKey={a} onSelect={e => setA(!e ? 0 : e)}>
       <Accordion.Collapse eventKey={0}>
        <>
         <ul className="fa-ul ms-2 ps-x1 mb-3">
          <li className="py-0">
           <h6 className="text-700 fs--2">
            <FontAwesomeIcon icon="plus" className="fa-li text-success" />
            Fecha de consignacion o transferencia
           </h6>
          </li>

          <li className="py-0">
           <h6 className="text-700 fs--2">
            <FontAwesomeIcon icon="plus" className="fa-li text-success" />
            Monto de la consignacion o transferencia
           </h6>
          </li>

          <li className="py-0">
           <h6 className="text-700 fs--2">
            <FontAwesomeIcon icon="plus" className="fa-li text-success" />
            Referencia unica de la consignacion o transferencia
           </h6>
          </li>
         </ul>

         <div className="position-relative">
          <UploadFiles
           className="mb-2"
           multiple={false}
           accept="image/*"
           dropzoneArea={true}
           onChange={e => setRcb(e)}
           register={register('payment_method.image', { required: 'imagen de consignacion o transferencia requerida' })}
           placeholder={
            <div>
             <img src={cloudUpload} alt="" width={25} className="me-2" />
             Subir recibo de consignacion
            </div>
           }
          />
          <SoftBadge pill bg="primary" className="me-3 position-absolute fs--2 top-0 end-0 translate-middle-y z-index-1">
           <FontAwesomeIcon icon="clock" className="me-1" />
           imagen de recibo
          </SoftBadge>
         </div>

         {errors?.payment_method?.image && (
          <Alert variant="danger" className="fs--2">
           <strong>imagen</strong> de consignacion o transferencia <strong>requerida</strong>
          </Alert>
         )}
        </>
       </Accordion.Collapse>
       {rcb.length > 0 &&
        rcb.map(({ id, path, base64, size }, i) => (
         <Card className="mb-2" key={i + 1}>
          <Card.Header className="py-2">
           <CustomToggle eventKey={i + 1} id={id} base64={base64} path={path} size={size}>
            <Button
             variant="falcon-primary"
             type="button"
             className="p-0 icon-item icon-item-sm"
             onClick={() => {
              setA(0);
              setRcb(rcb.filter(file => file.id !== id));
             }}
            >
             <FontAwesomeIcon icon="trash" />
            </Button>
           </CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey={i + 1}>
           <SimpleBarReact style={{ maxHeight: '165px' }}>
            <Card.Body className="p-0">
             <FalconLightBox image={base64}>
              <Image alt={path} src={base64} fluid />
             </FalconLightBox>
            </Card.Body>
           </SimpleBarReact>
          </Accordion.Collapse>
         </Card>
        ))}
      </Accordion>
     </Col>
     <Col md={6} className="mt-4 mt-lg-0 pb-3">
      <div className="h-100 rounded border-lg border-1 flex-lg-column p-lg-3">
       <Input
        type="text"
        errors={errors}
        label="Ref.*" // referencia unica de la consignacion o transferencia
        name={['payment_method', 'ref']}
        placeholder="Referencia unica"
        formLabelProps={{ column: true, xs: 3, sm: 4, className: 'text-lg-end fs--1' }}
        formColumnProps={{ xs: 9, sm: 8, className: '' }}
        formGroupProps={{ as: Row, className: 'mb-3' }}
        formControlProps={{ ...register('payment_method.ref', { required: true }), className: 'fs--1' }}
       />

       <Input
        type="text"
        errors={errors}
        label="Monto*" // Monto de la consignacion o transferencia
        name={['payment_method', 'amount']}
        placeholder="Monto del recibo"
        formLabelProps={{ column: true, xs: 3, sm: 4, className: 'text-lg-end fs--1' }}
        formColumnProps={{ xs: 9, sm: 8, className: '' }}
        formGroupProps={{ as: Row, className: 'mb-3' }}
        formControlProps={{ name: 'amount', value: amount, onChange: handleChange, className: 'fs--1' }}
       />

       <Form.Control
        type="hidden"
        {...register('payment_method.amount', {
         required: true,
         validate: value =>
          value >= watch('amount') || 'El abono debe ser >= al monto a pagar ' + numeral(watch('amount')).format('$0,0[.]00')
        })}
       />

       <Input
        type="simple-date"
        errors={errors}
        label="Fecha*" // Fecha de consignacion o transferencia
        name={['payment_method', 'date']}
        placeholder="Fecha del recibo"
        formLabelProps={{ column: true, xs: 3, sm: 4, className: 'text-lg-end fs--1' }}
        formColumnProps={{ xs: 9, sm: 8, className: '' }}
        formGroupProps={{ as: Row, className: 'mb-3' }}
        formControlProps={{
         ...register('payment_method.date', {
          required: true,
          max: { value: new Date().toISOString().split('T')[0], message: 'La fecha debe ser <= a la actual' }
         }),
         className: 'fs--1',
         max: new Date().toISOString().split('T')[0]
        }}
       />

       {/* <Input
        type="text"
        errors={errors}
        label="Cuenta*" // Cuenta de la empresa
        name={['payment_method', 'account']}
        placeholder="Cuenta de la empresa"
        formLabelProps={{ column: true, xs: 3, sm: 4, className: 'text-lg-end fs--1' }}
        formColumnProps={{ xs: 9, sm: 8, className: '' }}
        formGroupProps={{ as: Row, className: 'mb-3' }}
        formControlProps={{ ...register('payment_method.account', { required: true }), size: 'sm' }}
       /> */}
      </div>
     </Col>
    </Row>

    {errors?.documents && <Alert variant="danger" message={errors?.documents?.message} />}
   </div>
  </Collapse>
 );
};

CustomToggle.propTypes = {
 children: PropTypes.node,
 eventKey: PropTypes.number,
 id: PropTypes.string,
 base64: PropTypes.string,
 path: PropTypes.string,
 size: PropTypes.number
};

RcbForm.propTypes = {
 show: PropTypes.bool.isRequired,
 register: PropTypes.func,
 watch: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object
};

export default RcbForm;
